
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/article/[slug]",
      function () {
        return require("private-next-pages/help/article/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/article/[slug]"])
      });
    }
  